import { useRef } from 'react';

/** The latest value from a render where `isHeld` was false: the value is kept while it is true. */
export function useHeldWhile<T>(value: T, isHeld: boolean): T {
  const heldRef = useRef(value);
  if (!isHeld) {
    heldRef.current = value;
  }
  return heldRef.current;
}
